export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7fddc075baa7c564d5675ecebc334a223268d387e7&name=apiMindbox!'